


































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  CatatanHarianBblObservasiInterface,
  NEONATAL_VITAL_RANGES,
} from "@/types/catatan_harian_bbl";

interface RowInput {
  id: number | null;
  suhu: number | null;
  spo2: number | null;
  rr: number | null;
  hr: number | null;
  feses: string;
  muntah_residu: string;
  urin: string;
  minuman_oral: string;
  minuman_iv: string;
  catatan_tindakan: string;
}

@Component
export default class BblObservasiGrid extends Vue {
  @Prop({ type: Array, default: () => [] })
  observasi!: CatatanHarianBblObservasiInterface[];

  @Prop({ type: Number, required: true })
  catatanId!: number;

  @Prop({ type: Boolean, default: false })
  locked!: boolean;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  rowData: Record<number, RowInput> = {};
  dirtyRows: Record<number, boolean> = {};

  created(): void {
    this.initRows();
  }

  @Watch("observasi", { deep: true })
  onObservasiChange(): void {
    this.initRows();
  }

  initRows(): void {
    const obsMap: Record<number, CatatanHarianBblObservasiInterface> = {};
    for (const obs of this.observasi) {
      obsMap[obs.jam] = obs;
    }

    const newRowData: Record<number, RowInput> = {};
    const newDirty: Record<number, boolean> = {};

    for (let jam = 1; jam <= 24; jam++) {
      const existing = obsMap[jam];
      newRowData[jam] = {
        id: existing ? existing.id : null,
        suhu: existing ? existing.suhu : null,
        spo2: existing ? existing.spo2 : null,
        rr: existing ? existing.rr : null,
        hr: existing ? existing.hr : null,
        feses: existing ? existing.feses || "" : "",
        muntah_residu: existing ? existing.muntah_residu || "" : "",
        urin: existing ? existing.urin || "" : "",
        minuman_oral: existing ? existing.minuman_oral || "" : "",
        minuman_iv: existing ? existing.minuman_iv || "" : "",
        catatan_tindakan: existing ? existing.catatan_tindakan || "" : "",
      };
      newDirty[jam] = false;
    }

    this.rowData = newRowData;
    this.dirtyRows = newDirty;
  }

  markDirty(jam: number): void {
    this.$set(this.dirtyRows, jam, true);
  }

  getObsId(jam: number): number | null {
    const row = this.rowData[jam];
    return row ? row.id : null;
  }

  saveRow(jam: number): void {
    const row = this.rowData[jam];
    if (!row) return;

    this.$emit("save-observasi", {
      id: row.id,
      catatan_harian_bbl_id: this.catatanId,
      jam,
      suhu: row.suhu,
      spo2: row.spo2,
      rr: row.rr,
      hr: row.hr,
      feses: row.feses || null,
      muntah_residu: row.muntah_residu || null,
      urin: row.urin || null,
      minuman_oral: row.minuman_oral || null,
      minuman_iv: row.minuman_iv || null,
      catatan_tindakan: row.catatan_tindakan || null,
    });

    this.$set(this.dirtyRows, jam, false);
  }

  deleteRow(jam: number): void {
    const obsId = this.getObsId(jam);
    if (obsId) {
      this.$emit("delete-observasi", obsId);
    }
  }

  getAlertLevel(
    param: "suhu" | "spo2" | "rr" | "hr",
    value: number | null
  ): "critical" | "warning" | "normal" {
    if (value === null || value === undefined) return "normal";

    const ranges = NEONATAL_VITAL_RANGES[param] as Record<string, number>;

    if (param === "suhu") {
      if (value < ranges.critical_min || value > ranges.critical_max)
        return "critical";
      if (
        (value >= ranges.warning_min && value < ranges.normal_min) ||
        (value > ranges.normal_max && value <= ranges.warning_max)
      )
        return "warning";
      return "normal";
    }

    if (param === "spo2") {
      if (value < ranges.critical_min) return "critical";
      if (value >= ranges.warning_min && value < ranges.normal_min)
        return "warning";
      return "normal";
    }

    if (param === "hr" || param === "rr") {
      if (value < ranges.critical_min || value > ranges.critical_max)
        return "critical";
      if (value < ranges.normal_min || value > ranges.normal_max)
        return "warning";
      return "normal";
    }

    return "normal";
  }

  getCellClass(jam: number, param: "suhu" | "spo2" | "rr" | "hr"): string {
    const row = this.rowData[jam];
    if (!row) return "";

    const value = row[param] as number | null;
    const level = this.getAlertLevel(param, value);

    if (level === "critical") return "cell-critical";
    if (level === "warning") return "cell-warning";
    return "";
  }
}
